export type UnmovedUser = {
  user_id: string
  name: string | null
  reason: string
}

export type MoveOutcome = {
  successMessage?: string
  errorMessage?: string
  shouldClose: boolean
}

export const describeMoveResult = (
  requestedCount: number,
  teamName: string,
  unmoved: UnmovedUser[],
): MoveOutcome => {
  const movedCount = Math.max(requestedCount - unmoved.length, 0)
  const outcome: MoveOutcome = { shouldClose: unmoved.length === 0 }

  if (movedCount > 0) {
    const people = movedCount === 1 ? 'person' : 'people'
    outcome.successMessage = `${movedCount} ${people} moved to ${teamName}`
  }

  if (unmoved.length > 0) {
    const names = unmoved.map((user) => user.name || 'one person').join(', ')
    outcome.errorMessage = `Could not move ${names}`
  }

  return outcome
}
